import type { WatchlistItem } from "../../reducers/watchlist";

export const makeWatchlistKey = (aff: number | string, abo: number | string): string => `${+aff}-${abo}`;

export const buildWatchlistSet = (items: WatchlistItem[]): Set<string> =>
  new Set(items.map((item) => makeWatchlistKey(item.Aff, item.ABONo)));
